import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {externalId} from "#template/nodes/validation"
import {MetaData} from "#template/nodes/meta-data"

export const exportNodeParameters = <ItemType>(itemSchema: z.ZodMiniType<ItemType, ItemType>) =>
    z.object({
        name: z.string(),
        id: externalId,
        node: z.nullable(itemSchema),
        metaData: z.optional(graphNode(MetaData)),
    })
